import IntegrationConfiguration from "models/OrganizationModels/OrganizationIntegrationConfiguration";
import BaseService from "./BaseService";

export class IntegrationService extends BaseService {
    protected urlBase: string = "api/Integrations";

    public async getIntegrationConfiguration(organizationId: string) {
        const body = JSON.stringify({ organizationId });
        const res = this.post(body, new URLSearchParams({}), "List");
        return await res;
    }

    public async updateIntegrationConfiguration(
        value: IntegrationConfiguration[],
        organizationId: string,
    ) {
        const formattedItems = value.map((item: IntegrationConfiguration) => {
            return {
                ...item,
                name: item.type,
                baseIntegrationUri: item.url,
                lastUpdate: item.lastUpdate,
                // filter out empty string queueIds
                configuration: item.configuration &&
                    item.configuration?.customConfiguration && {
                        ...item.configuration,
                        customConfiguration: {
                            ...item.configuration?.customConfiguration,
                            queueIds:
                                item.configuration?.customConfiguration.queueIds?.filter(
                                    (qId) => !!qId,
                                ),
                        },
                    },
            };
        });

        const stringifiedItem = JSON.stringify(formattedItems);
        const res = this.post(
            stringifiedItem,
            new URLSearchParams({ organizationId }),
            "Update",
        );
        return await res;
    }

    public async getKeyNames(integrationType: string) {
        const res = this.get(
            new URLSearchParams({ integrationType }),
            "GetKeyNames",
        );
        return await res;
    }

    public async checkKeys(integrationId: string) {
        const res = this.get(
            new URLSearchParams({ integrationId }),
            "CheckKeysDefinedForIntegration",
        );
        return await res;
    }

    public async updateSecrets(
        integrationId: string,
        secrets: {
            [x: string]: string;
        },
    ) {
        const res = this.post(
            JSON.stringify(secrets),
            new URLSearchParams({ integrationId }),
            "UpdateSecrets",
        );
        return await res;
    }
}
